export default "{\n    me {\n        name\n    }\n}\n"